import React, { useEffect } from "react";
import {
  makeStyles,
  Typography,
  Chip,
  Container,
  Box,
  useTheme,
  Card,
  CardHeader,
  Divider,
  CardContent,
} from "@material-ui/core";

import MaterialTable from "material-table";
import { useHistory } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import { AlertTitle, Alert } from "@material-ui/lab";

import _ from "lodash";
import {
  addRole,
  deleteRole,
  getAllPermissions,
  getAllRoles,
} from "src/redux/actions/backOffice.action";
import Page from "src/components/Page";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "25ch",
    maxWidth: 300,
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(id, permissions, theme) {
  let result = _.findIndex(permissions, { ID: id });

  return {
    color: result !== -1 ? "green" : "black",
  };
}

const RoleManagementSettingComponent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { roles } = useSelector((state) => state.backOfficeReducer);

  useEffect(() => {
    dispatch(getAllRoles());
    dispatch(getAllPermissions());
  }, []);

  if (roles.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert — <strong>Get Roles data!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page className={classes.root} title="Role Management">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For the role management on the system."
            title="Role Management"
          />
          <Divider />
          <CardContent>
            <Box display="flex">
              <Box flexGrow={1}>
                <MaterialTable
                  title
                  isLoading={roles.isLoading}
                  columns={[
                    {
                      title: "Name",
                      field: "NAME",
                    },
                    {
                      title: "Permission",
                      field: "PERMISSIONs",
                      render: (rowData) => {
                        return rowData.PERMISSIONs.map((i) => (
                          <>
                            <Chip
                              label={i.NAME}
                              style={{ margin: 2 }}
                              color="primary"
                            />
                          </>
                        ));
                      },
                      editable: false,
                    },
                    {
                      title: "Create Date",
                      field: "CREATED_AT",
                      type: "datetime",
                      defaultSort: "desc",
                      editable: false,
                    },
                  ]}
                  data={roles.data}
                  actions={[
                    (rowData) => ({
                      icon: "edit",
                      onClick: (event, rowData) => {
                        event.preventDefault();
                        history.push(`role-management-edit/${rowData.ID}`);
                      },
                    }),
                  ]}
                  editable={{
                    onRowAdd: (newData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          dispatch(
                            addRole({
                              ...newData,
                              APP_CODE: "PRS001",
                              APP_NAME: "PRS System",
                            })
                          );
                          resolve();
                        }, 1000);
                      }),
                    // onRowUpdate: (newData, oldData) =>
                    //   new Promise((resolve, reject) => {
                    //     setTimeout(() => {
                    //       console.log(newData);
                    //       dispatch(updateRole(newData.ID, newData));
                    //       resolve();
                    //     }, 1000);
                    //   }),
                    onRowDelete: (oldData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          dispatch(deleteRole(oldData.ID));
                          resolve();
                        }, 1000);
                      }),
                  }}
                  options={{
                    filtering: true,
                    // actionsColumnIndex: -1,
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default RoleManagementSettingComponent;
